import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../emitter/Observer';
import { ModalResultFinalTeam } from '../../components/common/ModalResultFinalTeam';
import { audiosAssets } from '../../assets/audio';

export const SubtopicFinalTeam3 = () => {
	const { loaded } = useSelector(state => state.menu)

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 final");
			ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 6);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded])
	return (
		<>
			<ModalResultFinalTeam
				title='¡Felicidades!'
				subTitle='¡Concluiste el Tema 3!'
				buttonText='Iniciar Tema 4'
				actionButton={() => {
					window.location.href = "/home4/tema4/introduction";
				}} actionBack={() => {
					window.location.href = "/home1";
				}}

			/>
		</>
	)
}


